/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */

module.exports = require('./../../lib/adapters/react-dom').default;
